
// import React from "react";
// import "./TeamSection.css";
// import { FaLinkedin } from "react-icons/fa";

// import abhinavsir from "../../assets/Teams/abhinavsir.webp";
// import svsinghsir from "../../assets/Teams/SVsinghsir.webp";
// import Sweta from "../../assets/Teams/sweta.webp";
// import Kiranmam from "../../assets/Teams/kiranmam.webp";
// import Mohit from "../../assets/Teams/mohit.webp";
// import naman from "../../assets/Teams/naman.webp";
// import Gauri from "../../assets/Teams/gauri.webp";
// import Tanveer from "../../assets/Teams/Tanveer.webp";
// import Mitali from "../../assets/Teams/Mitali.webp";
// import Harsh from "../../assets/Teams/harsh.webp";
// import prachi from "../../assets/Teams/Prachi.webp";

// // import Shovitsir from "../../assets/Teams/shovitsir.webp";

// const teamMembers = [
//   {
//     name: "S.V. Singh",
//     role: "Director",
//     img: svsinghsir,
//   },
//   {
//     name: "Abhinav Vikram Singh",
//     role: "Business Head",
//     img: abhinavsir,
//     linkedin: "https://www.linkedin.com/in/abhinav-singh-22017a8a/",
//   },
//   {
//     name: "Kiran Suri",
//     role: "HR",
//     img: Kiranmam,
//     linkedin: "https://www.linkedin.com/in/kiran-mehra-7521a3385?utm_source=share_via&utm_content=profile&utm_medium=member_android",
//   },
//   {
//     name: "Gauri",
//     role: "Operations",
//     img: Gauri,
//     linkedin: "https://www.linkedin.com/in/gauri-pal-9a09b522b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
//   },
//      {
//     name: "Prachi Rawat",
//     role: "Mice Support Executive",
//     img: prachi,
//     linkedin: "https://www.linkedin.com/in/prachi-rawat-4aba52286?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
//   },
//   {
//     name: "Sweta",
//     role: "Creative",
//     img: Sweta,
//     linkedin: "http://linkedin.com/in/sweta-kumari-741151350",
//   },
//   // {
//   //   name: "Shovit Kumar",
//   //   role: "Ticketing",
//   //   img: Shovitsir,
//   //   linkedin: "https://www.linkedin.com/in/shovit-kumar-0ba6ab395/",
//   // },
//   {
//     // name: "Harsh Rajput",
//         name: "Harsh Singh",
//     role: "Sales",
//     img: Harsh,
//     linkedin: "https://www.linkedin.com/in/harsh-singh-6abb89357?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
//   },
//   {
//     name: "Tanveer Kaur ",
//     role: "Mice Sales Departure",
//     img: Tanveer,
//     linkedin: "https://www.linkedin.com/in/tanveer-kaur-740638392",
//   },
//   // {
//   //   name: "Mitali Sibbal ",
//   //   role: "Mice Sales Departure",
//   //   img: Mitali,
//   //   linkedin: "http://www.linkedin.com/in/mitali-sibbal-551959397",
//   // },
//   {
//     name: "Mohit",
//     role: "3D Designer",
//     img: Mohit,
//     linkedin: "https://www.linkedin.com/in/mohit-kumar-6a1308368?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
//   },
//   {
//     name: "Naman Mishra",
//     role: "SDE",
//     img: naman,
//     linkedin: "https://www.linkedin.com/in/naman-mishra-a67821226",
//   },
// ];

// const topMembers = teamMembers.slice(0, 1);
// const bottomMembers = teamMembers.slice(1);

// const TeamSection = () => {
//   return (
//     <section className="team-section">
//       {/* this is the update */}
//       <h1 className="teamheading">Meet the People Who Make It Happen</h1>
//       <div className="underline"></div>

//       <div className="team-container top-row">
//         {topMembers.map((member, index) => (
//           <div className="team-card" key={index}>
//             <div className="profile-wrapper">
//               <img src={member.img} alt={member.name} className="profile-img" />
//             </div>
//             <div className="name">{member.name}</div>
//             <div className="role">{member.role}</div>

//             {member.linkedin && (
//               <a
//                 href={member.linkedin}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="linkedin-icon"
//               >
//                 <FaLinkedin />
//               </a>
//             )}
//           </div>
//         ))}
//       </div>

//       <div className="team-container bottom-row">
//         {bottomMembers.map((member, index) => (
//           <div className="team-card" key={index + 2}>
//             <div className="profile-wrapper">
//               <img src={member.img} alt={member.name} className="profile-img" />
//             </div>
//             <div className="name">{member.name}</div>
//             <div className="role">{member.role}</div>

//             {member.linkedin && (
//               <a
//                 href={member.linkedin}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="linkedin-icon"
//               >
//                 <FaLinkedin />
//               </a>
//             )}
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default TeamSection;




import React from "react";
import { motion } from "framer-motion";
import styles from "./TeamSection.module.css";

import svsinghsir from "../../assets/Teams/SVsinghsir.webp";

const TeamSection = () => {
  return (
    <section className={styles.directorSection}>
      <div className={styles.card}>

        {/* LEFT IMAGE */}
        <motion.div
          className={styles.imageWrapper}
          initial={{ x: -120, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <img
            src={svsinghsir}
            alt="S.V. Singh"
            className={styles.image}
          />
        </motion.div>

        {/* RIGHT CONTENT */}
        <motion.div
          className={styles.content}
          initial={{ x: 120, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h2 className={styles.name}>
            Mr. Satyendra Vikram Singh
          </h2>

          <p className={styles.designation}>
            Director, Atlas Travel House
          </p>

          <p className={styles.message}>
            At Atlas Travel House, our vision has always been
            to create meaningful travel and event experiences
            that leave a lasting impression. With a commitment
            to quality, trust, and innovation, we continue to
            deliver journeys and events that connect people,
            inspire memories, and build long-term relationships.
          </p>
        </motion.div>

      </div>
    </section>
  );
};

export default TeamSection;